/** For some reason this works, but react-app-polyfill/stable doesn't */
import 'core-js/stable';
import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { ThemeProvider } from 'styled-components/macro';
/** Lightpaper components */
import AppHead from './containers/AppHead';
import Routes from './containers/Routes';
import GlobalStyle from './components/GlobalStyle';
import ScrollToSection from './components/ScrollToSection';
/** Logic modules */
import store, { history } from './logic/store';
import {
  loadContent,
  headerIsUnderFirstSectionSet,
  setGateRelease,
} from './logic/actions';
import { readCookie, getUrlParameter } from './utilities';
/** Config */
import config from './config';
import theme from './config/theme';
/** And this guy */
// import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

/** Initiate loading content, defining whether the content is local or remote */
store.dispatch(loadContent(config.shouldUseRemoteContent, config.contentful));

/** Save a step and check for this config option before dispatching it */
if (
  config.isHeaderUnderFirstBlock ||
  config.isHeaderUnderFirstBlock === false
) {
  store.dispatch(headerIsUnderFirstSectionSet(config.isHeaderUnderFirstBlock));
}

/** Initial check for releasing the gate, without setting the gate cookie */
if (getUrlParameter('nogate') === 'true' || readCookie('gate-released')) {
  store.dispatch(setGateRelease(true));
}

/** The entry point to the lightpaper */
ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <ConnectedRouter history={history}>
        <>
          <GlobalStyle />
          <AppHead />
          <main>
            <Routes />
          </main>
          <ScrollToSection />
        </>
      </ConnectedRouter>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
);

// registerServiceWorker();
unregister();
